export default __webpack_public_path__ + "static/media/DSYEpilogThumbnail.b6662f6e.svg";